/* eslint-disable react/prefer-stateless-function */
import React, { useEffect, useState } from 'react'
import * as _ from 'lodash'
import UserEventEmitterContext from '../contexts/UserEventEmitterContext'
import hoistNonReactStatics from 'hoist-non-react-statics'
import get from 'lodash/get'

import forwardInnerRef from './forwardInnerRef'

const withDiscounts = WrappedComponent => {
  const MyComponent = props => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    const [discounts, setDiscounts] = useState([])

    useEffect(() => {
      if (!props.space) {
        setLoading(false)
        setError(true)
        setDiscounts([])
        return
      }

      if (!props.space.reservable) {
        setLoading(false)
        setError(true)
        setDiscounts([])
        return
      }
      const fetchDiscount = async (reservableId, buildingId) => {
        if (!props.floorMap) {
          setLoading(false)
          setError(true)
          setDiscounts([])

          return
        }
        const discountExtension = props.floorMap.getExtension('discount')

        if (!discountExtension) {
          setLoading(false)
          setError(true)
          setDiscounts([])
          return
        }

        setLoading(true)
        setError(false)
        setDiscounts([])

        try {
          const discounts = await discountExtension.getDiscounts(
            buildingId,
            reservableId
          )
          const sorted = _.sortBy(discounts, ['length'])

          const currentUUID = get(props, 'space.reservable.uuid')
          if (currentUUID !== reservableId) {
            return
          }
          setLoading(false)
          setError(false)
          setDiscounts(sorted)
        } catch (e) {
          console.error(e)
          setLoading(false)
          setError(true)
          setDiscounts([])
        }
      }
      fetchDiscount(
        props.space.reservable.uuid,
        props.space.reservable.propertyUUID
      )

      return () => {
        setLoading(false)
        setError(false)
        setDiscounts([])
      }
    }, [props, props.space])

    return (
      <>
        <WrappedComponent
          {...props}
          discounts={discounts}
          loadingDiscounts={loading}
          discountsError={error}
        />
      </>
    )
  }

  return MyComponent
}
export default withDiscounts
